import { DOCUMENT, Inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';
import {
  DEFAULT_LANGUAGE_CODE,
  SUPPORTED_ENGLISH_CODES,
  SUPPORTED_SPANISH_CODES,
} from '../constant';

@Injectable({
  providedIn: 'root',
})
export class TranslationConfigService {
  constructor(
    private translate: TranslateService,
    @Inject(DOCUMENT) private document: Document,
  ) {}

  setLocale(lmsLocale?: string): Promise<Record<string, string> | void> {
    let languageCode = DEFAULT_LANGUAGE_CODE.ENGLISH;

    if (SUPPORTED_ENGLISH_CODES.includes(lmsLocale!)) {
      languageCode = DEFAULT_LANGUAGE_CODE.ENGLISH;
    } else if (SUPPORTED_SPANISH_CODES.includes(lmsLocale!)) {
      languageCode = DEFAULT_LANGUAGE_CODE.SPANISH;
    }

    // set html lang for screen readers
    this.document.documentElement.lang = languageCode;

    return firstValueFrom(this.translate.use(languageCode))
      .catch(() =>
        languageCode !== DEFAULT_LANGUAGE_CODE.ENGLISH
          ? firstValueFrom(
              this.translate.use(DEFAULT_LANGUAGE_CODE.ENGLISH),
            ).catch(() => {})
          : Promise.resolve(),
      )
      .then(() => {});
  }
}
